export const referalUrl: Record<string, string> = {
    us: '/ecoflow-ambassador-program',
    fr: '/programme-ambassadeur-ecoflow',
    de: '/ecoflow-botschafter-programm',
};

export const referraledUrl: Record<string, string> = {
    us: 'ambassador-program-referred',
    fr: 'programme-ambassadeur-ecoflow-referred',
    de: 'ecoflow-botschafter-programm-referred',
};
